<template>
  <div class="content">
    <!-- 新增按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">新增卡券限制</el-button>
        <span style="margin: 0 20px;color: red;"
          >不设置数量的日期默认为不可兑换</span
        >
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="dataList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>

        <el-table-column label="限制核销时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.date ? scope.row.date : "暂无" }}
          </template>
        </el-table-column>
        <el-table-column label="限制核销数量" align="center">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" class="text-hide">
                {{ scope.row.maxNum ? scope.row.maxNum : "暂无" }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <!-- <el-button size="mini" @click="ejectupdataGoods(scope.row)"
              >修改</el-button
            > -->
            <el-button size="mini" type="danger" @click="deleteBtn(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增表单 -->
    <el-dialog
      :title="inputTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="设置核销时间" label-width="150px">
          <el-date-picker
            type="date"
            is-range
            value-format="yyyy-MM-dd"
            v-model="form.date"
          >
          </el-date-picker
        ></el-form-item>
        <el-form-item label="限制核销数量" label-width="150px">
          <el-input
            v-model="form.maxNum"
            auto-complete="off"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectCouponConfig,
  addCouponConfig,
  deleteCouponConfig,
} from "@/services/cardCoupon.js";
export default {
  data() {
    return {
      dataList: [],
      inputTitle: "新增",
      cover: "",
      fileList: [], //上传列表
      action: "https://mini-xili.bboycc.cn/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {
    // 查询用户登陆数据
    this.selectApi();
  },
  methods: {
    // 查询
    selectApi() {
      selectCouponConfig().then((resp) => {
        console.log(resp.data);
        this.loading = false;
        this.dataList = resp.data;
      });
    },
    // 新增按钮
    kaihuBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
      this.fileList = [];
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },
    /* 上传图片 */
    handleSuccess_cover(e) {
      console.log(e.data);
      this.form.url = e.data;
      // console.log(this.form);
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (
        this.form.maxNum == "" ||
        this.form.maxNum == null ||
        this.form.date == "" ||
        this.form.date == null
      ) {
        this.$message.error("请填写");
        return;
      }

      addCouponConfig(this.form).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "新增成功!",
          });
          this.selectApi();
        } else {
          this.$message({
            type: "info",
            message: "网路错误",
          });
        }
      });

      // if (this.inputTitle == "新增") {
      //   addCouponConfig(this.form.name).then((res) => {
      //     console.log(res);
      //     if (res.code == 200) {
      //       this.dialogFormVisible = false;
      //       this.$message({
      //         type: "success",
      //         message: "新增成功!",
      //       });
      //       this.selectApi();
      //     } else {
      //       this.$message({
      //         type: "info",
      //         message: "网路错误",
      //       });
      //     }
      //   });
      //   return;
      // }

      // updateAdress(this.form.id, this.form.name).then((res) => {
      //   console.log(res);
      //   if (res.code == 200) {
      //     this.dialogFormVisible = false;
      //     this.$message({
      //       type: "success",
      //       message: "修改成功!",
      //     });
      //     this.selectApi();
      //   } else {
      //     this.$message({
      //       type: "info",
      //       message: "网络错误",
      //     });
      //   }
      // });
    },

    // 删除
    deleteBtn(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteCouponConfig(row.id).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectApi();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
